import App from '@/components/App';
import Home from '@/components/Home';
import Demo from '@/components/Demo';
import Desktop from '@/components/Desktop';
import VirtApp from '@/components/VirtApp';

export default
[
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/init/:clientKey',
		name: 'Init-ClientKey'
	},
	{
		path: '/init/:clientKey/:userToken',
		name: 'Init-ClientKey-UserToken'
	},
	{
		path: '/demo',
		name: 'Demo',
		component: Demo
	},
	{
		path: '/desktop/:type',
		name: 'Desktop',
		component: Desktop,
		props: true,
		
		children:
		[
			{ path: ':action/:uuid' }
		]
	},
	{
		path: '/virtapp',
		name: 'Virtual Application',
		component: VirtApp,
		props: true,
		
		children:
		[
			{ name: 'Virtual Application Action', path: ':action/:uuid' }
		]
	}
];
